import React from 'react';
import { FiInfo } from 'react-icons/fi';

const InfoAlertBanner = () => {
  return (
    <div className="w-full bg-[#F5F8FF] border border-[#E0E9FF] rounded-xl px-4 py-10 mt-10 font-sans flex items-start gap-3 shadow-[0_1px_4px_rgba(0,0,0,0.01)] select-none">
      
      {/* Left side: Blue Info Icon */}
      <div className="text-[#0052FF] mt-0.5 shrink-0">
        <FiInfo className="w-4 h-4 stroke-[2.5]" />
      </div>

      {/* Right side: Alert message and timestamp */}
      <div className="space-y-1">
        <p className="text-[13px] font-bold text-[#1E3A8A] tracking-tight leading-none">
          All sensors are working correctly and temperatures are within safe range.
        </p>
        <span className="text-[11px] font-semibold text-gray-400 block">
          Last updated: 26 May 2025, 09:32 AM
        </span>
      </div>

    </div>
  );
};

export default InfoAlertBanner;
